// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2UuX4","content":"styles_content__2915y","checkbox":"styles_checkbox__1Bj-n","checkboxLabel":"styles_checkboxLabel__1kIyM"};